import React from 'react';
import { TrendingDown, TrendingUp } from 'lucide-react';

import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';

const colorMap = {
  blue: 'bg-blue-500/15 text-blue-400 ring-blue-500/20',
  green: 'bg-emerald-500/15 text-emerald-400 ring-emerald-500/20',
  red: 'bg-rose-500/15 text-rose-400 ring-rose-500/20',
  yellow: 'bg-amber-500/15 text-amber-400 ring-amber-500/20',
  purple: 'bg-purple-500/15 text-purple-400 ring-purple-500/20',
};

export default function StatCard({
  title,
  value,
  change = 0,
  changeLabel,
  icon,
  color = 'blue',
}) {
  const isPositive = Number(change) >= 0;
  const ChangeIcon = isPositive ? TrendingUp : TrendingDown;

  return (
    <Card className="border-slate-700 bg-slate-800 shadow-lg transition-transform duration-200 hover:scale-[1.02]">
      <CardContent className="p-5">
        <div
          className={cn(
            'mb-5 flex h-12 w-12 items-center justify-center rounded-2xl ring-1',
            colorMap[color] || colorMap.blue
          )}
        >
          {icon}
        </div>
        <p className="text-sm font-medium text-slate-400">{title}</p>
        <p className="mt-2 text-3xl font-bold tracking-tight text-white">{value}</p>
        <div className="mt-4 flex items-center gap-2 text-sm">
          <span
            className={cn(
              'inline-flex items-center gap-1 rounded-full px-2.5 py-1 font-medium',
              isPositive
                ? 'bg-emerald-500/10 text-emerald-400'
                : 'bg-rose-500/10 text-rose-400'
            )}
          >
            <ChangeIcon className="h-4 w-4" />
            {Math.abs(Number(change)).toFixed(0)}%
          </span>
          <span className="text-slate-500">{changeLabel}</span>
        </div>
      </CardContent>
    </Card>
  );
}
